import { render, staticRenderFns } from "./PreviewQuestionModal.vue?vue&type=template&id=3b98b59b&scoped=true&"
import script from "./PreviewQuestionModal.vue?vue&type=script&lang=js&"
export * from "./PreviewQuestionModal.vue?vue&type=script&lang=js&"
import style0 from "./PreviewQuestionModal.vue?vue&type=style&index=0&id=3b98b59b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b98b59b",
  null
  
)

export default component.exports